import { Injectable } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { DataSourcesEnum } from '../enums/DataSourcesEnum';
import { PageTypeEnum } from '../enums/PageTypeEnum';
import { IDataLoaded } from '../interfaces/IDataLoaded';
import { ILGEEvent } from '../interfaces/ILGEEvent';
import { ISelectPage } from '../interfaces/ISelectPage';
import { DataStore } from '../models/DataStore';
import { LGCouncil } from '../models/LGCouncil';
import { LGE } from '../models/LGE';
import { LGElection } from '../models/LGElection';
import { ApiDataService } from './api-data.service';

@Injectable({
  providedIn: 'root'
})
export class LgElectionService {
  public isMobile = false;
  public isTablet = false;
  public isDesktop = false;

  public dataLoaded$: Subject<IDataLoaded> = new Subject<IDataLoaded>();
  public menuLoaded$ = new Subject();
  public electionMap: Map<string, DataStore> = new Map<string, DataStore>();
  private pollingIntervalTimer: any;
  public menuPhoneClick$ = new Subject();
  public currentCouncil: LGCouncil | null = null;
  public pageChanged$: Subject<ISelectPage> = new Subject<ISelectPage>();
  public selectedCouncilCode = 'ADE';
  public selectedElectionDate: string | null = null;
  public selectedPage: ISelectPage = {
    electionDateString: null,
    pageType: PageTypeEnum.Loading,
    countDistrict: '',
    electionDate: null
  };
  public electionEvents: ILGEEvent[] = [];

  //public electionDate = '2022-11-1';

  constructor(private apiDataService: ApiDataService) {
    let isMenuLoaded = false;
    apiDataService.loadLGEEvent$().subscribe(electionEvents => { 
      this.electionEvents = electionEvents;
    //  this.menuLoaded$.next();
      electionEvents.forEach(electionEvent => {
        this.electionMap.set(electionEvent.electionDate, new DataStore());

        apiDataService.loadLGEStatic$(electionEvent.electionDate, 0).subscribe(data => {
          const currentDataStore = this.electionMap.get(electionEvent.electionDate);
          currentDataStore?.addLGEStatic(data, electionEvent.nominationsClose);

          if (this.selectedElectionDate !== null && electionEvent.electionDate === this.selectedElectionDate) {
            this.currentCouncil = currentDataStore?.lge?.councils.find(x => x.councilCode === this.selectedCouncilCode) ?? null;
            this.reportDataLoaded(electionEvent.electionDate, DataSourcesEnum.LGEStatic);
            isMenuLoaded = true;
            this.menuLoaded$.next();
          }
          if (this.selectedElectionDate === null && electionEvent.isDefault) {
            this.currentCouncil = currentDataStore?.lge?.councils[0] ?? null; // find(x => x.councilCode === this.selectedCouncilCode) ?? null;
            this.reportDataLoaded(electionEvent.electionDate, DataSourcesEnum.LGEStatic);
            isMenuLoaded = true;
            this.menuLoaded$.next();
          }
          
        });

        if (electionEvent.electionStatus === 'inProgress') {
          this.pollingIntervalTimer = interval(5 * 60 * 1000)
            .pipe(
              startWith(0)
            )
          .subscribe(() => {
            const lgeVersion = this.electionMap.get(electionEvent.electionDate)?.lgeChange?.dataVersion ?? 0;
            apiDataService.loadLGEChange$(electionEvent.electionDate, lgeVersion).subscribe(data => {
              const currentDataStore = this.electionMap.get(electionEvent.electionDate);
              currentDataStore?.addLGEChange(data);
              this.reportDataLoaded(electionEvent.electionDate, DataSourcesEnum.LGEChange);
            });
          }, err => {} );
        } else {
          apiDataService.loadLGEChange$(electionEvent.electionDate, 0).subscribe(data => {
            const currentDataStore = this.electionMap.get(electionEvent.electionDate);
            currentDataStore?.addLGEChange(data);
            this.reportDataLoaded(electionEvent.electionDate, DataSourcesEnum.LGEChange);
          });
        }
      });
    });
  }


  public reportDataLoaded(electionDateString: string, dataSource: DataSourcesEnum): void {
    if (electionDateString !== '') {
      this.electionMap.get(electionDateString)?.dataSourceLoaded(dataSource);
    }
    this.dataLoaded$.next({ 
      electionDate: electionDateString,
      dataSource: dataSource
    });
  }

  // note the countDistrict here is the council
  public updatePage(electionDateString: string, pageType: PageTypeEnum, countDistrict: string | null, electionDate: Date | null): void {
    this.selectedPage.electionDateString = electionDateString;
    this.selectedPage.pageType = pageType;
    this.selectedPage.countDistrict = countDistrict;
    this.selectedPage.electionDate = electionDate;
    this.pageChanged$.next(this.selectedPage);
  }

  public getLGE(electionDateString: string): LGE | null {
    return this.electionMap.get(electionDateString)?.lge ?? null;
  }

  public checkMenu(): void {
    if (this.isMobile) {
      this.menuPhoneClick$.next();
    }
  }

}
